import { render, staticRenderFns } from "./CatchEvent.vue?vue&type=template&id=0b6abc80"
import script from "./CatchEvent.vue?vue&type=script&lang=js"
export * from "./CatchEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports